<template>

  <data-form :entity="server" model="servers" :fields="fields" :cancel="false" />

</template>

<script>
export default {
  name: 'server-settings',
  props: {
    'server': {
      type: Object,
      required: true
    }
  },
  computed: {
    fields () {
      return {
        'fqdn': {
          type: 'text',
          rules: [{ required: true }]
        },
        'description': {
          type: 'text',
          rules: [{ max: 80 }]
        },
        'owner_id': {
          type: 'select',
          options: this.filterOptions('owners')(),
          filter: this.filterOptions('owners'),
          rules: [{ required: false }]
        },
        'location_id': {
          type: 'select',
          options: this.filterOptions('locations')(),
          filter: this.filterOptions('locations'),
          rules: [{ required: false }]
        }
      }
    }
  },
  methods: {
    filterOptions (model, map = (model => ({ label: model.name, value: model.id }))) {
      return (query) => {
        const models = this.$store.getters[`${model}/data`](this.$store.dispatch)

        return models
          .map(map)
          .filter(option => option.label.toLowerCase().includes((query || '').toLowerCase()))
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ServerSettings.vue?556c4bd8